import { useSuspenseQuery } from '@apollo/client';

import { useExperiment } from '@xing-com/hub';

import type { TopCompaniesQueryVariables } from '../../graphql/queries/top-companies.gql-types';
import { TopCompaniesDocument } from '../../graphql/queries/top-companies.gql-types';

export const useTopCompanies = ({
  limit,
  offset,
}: TopCompaniesQueryVariables) => {
  const variables = {
    limit,
    offset,
    shouldHideKununuData: useExperiment('ABACUS-518') === 'B',
  };

  const response = useSuspenseQuery(TopCompaniesDocument, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return response;
};
